import { render, staticRenderFns } from "./ApprovalConfigurationDetailUpload.vue?vue&type=template&id=424464c1&"
import script from "./ApprovalConfigurationDetailUpload.vue?vue&type=script&lang=js&"
export * from "./ApprovalConfigurationDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports